"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _job = require("@/api/job/job");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'InstanceDetails',
  // 数据传递
  props: ['instanceId', 'fixedWidth', 'resultAll'],
  // eslint-disable-line
  data: function data() {
    return {
      instanceDetail: {},
      listQuery: {
        instanceId: undefined
      }
    };
  },
  watch: {
    instanceId: function instanceId() {
      this.fetchInstanceDetail();
    }
  },
  mounted: function mounted() {
    this.fetchInstanceDetail();
  },
  methods: {
    fetchInstanceDetail: function fetchInstanceDetail() {
      var _this = this;
      this.listQuery.instanceId = this.instanceId;
      (0, _job.queryInstanceDetail)(this.listQuery).then(function (response) {
        _this.instanceDetail = response.data.data;
      });
    },
    translateInstanceStatus: function translateInstanceStatus(status) {
      switch (status) {
        case 1:
          return '等待派发';
        case 2:
          return '等待Worker接收';
        case 3:
          return '运行中';
        case 4:
          return '失败';
        case 5:
          return '成功';
        case 9:
          return '手动取消';
        case 10:
          return '手动停止';
        default:
          return 'UNKNOWN';
      }
    }
  }
};